import MapCustomerFilter from './map-customer-filter'
import './styles.scss'

export default MapCustomerFilter